module.exports = __webpack_public_path__ + "img/STONNER-LION.56c1fd7b.jpg";